import { CapoPlugin } from "/home/aquarist/www/pipeclub/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];